<template>
	<div>
		<headers :headerActive="true"></headers>
		<div class="content">
			<div class="m-t-30 m-b-30">您的位置：新闻中心 > <span class="fb">{{type}}</span> > <span class="bg_color">{{title}}</span></div>
			<div class="b_bai p-l-30 p-r-30 p-t-30 p-b-30 m-b-50" v-html="content"></div>
		</div>
		<div class="">
			<bottoms></bottoms>
		</div>
	</div>
</template>

<script>
	import headers from './common/header.vue'
	import bottoms from './common/bottoms.vue'
	export default{
		components:{
			headers,bottoms
		},
		data(){
			return{
				content:"",
				type:"",
				title:""
			}
		},
		mounted(){
			this.getDetail()
		},
		methods:{
			getDetail(){
				this.$http.post('http://aqjd.aqpx.online/getNewsInfo',this.$qs.stringify({
					id:this.$route.query.id,
					userid:18,
				})).then(res=>{
					console.log(res)
					this.content = res.data.info.content
					this.title = res.data.info.title
					this.type = res.data.info.newsType
				})
			}
		}
	}
</script>

<style>
</style>
